module.exports = __webpack_public_path__ + "static/img/m_ai_progress.eee0223f.png";